import React, { memo, useCallback, useEffect, useMemo } from "react";
import { Form, Formik } from "formik";
import {
  getFormattedDriversList,
  getInitialDriverDetailsValues,
  getSortedOdfDriversList,
  isRouteDriverChanged,
  isRouteDriverSelected,
  isRouteReadOnly,
} from "./model";
import { validateDriverForm } from "./validators";
import UpdateDriverForm from "./components/updateDriverForm";
import { ValidationEffect } from "./components/validationEffect";
import { PLEASE_FIX_ERRORS } from "./messages";

const DriverDetailsDialog = ({
  formRef,
  route = {},
  handleSave,
  onSelectDriver,
  onChangePassword,
  onAddDriver,
  driver,
  odfDriver,
  onSelectOdfDriver,
  vehicles,
  sections,
  drivers,
  showErrorMsg,
}) => {
  const showValidationError = useCallback(() => {
    showErrorMsg(PLEASE_FIX_ERRORS);
  }, [showErrorMsg]);

  const handleSubmitDriver = useCallback(
    (values, { setSubmitting }) => {
      handleSave(values);
      setSubmitting(false);
    },
    [handleSave]
  );

  const handleSelectDriver = useCallback(
    (driverCode) => {
      onSelectDriver(driverCode);
    },
    [onSelectDriver]
  );

  const isReadOnly = useMemo(() => isRouteReadOnly(route), [route]);
  const driversList = useMemo(
    () => getFormattedDriversList(drivers, odfDriver),
    [drivers, odfDriver]
  );

  const odfDriversList = useMemo(() => getSortedOdfDriversList(drivers), [
    drivers,
  ]);

  const isDriverSelected = useMemo(() => isRouteDriverSelected(driver), [
    driver,
  ]);

  const isDriverChangedForRoute = useMemo(
    () => isRouteDriverChanged(route, driver),
    [driver, route]
  );

  const initialValues = useMemo(
    () => getInitialDriverDetailsValues(driver, odfDriver, sections),
    [driver, sections, odfDriver]
  );

  useEffect(() => {
    (async () => {
      if (driver?.password) {
        await navigator.clipboard.writeText(driver?.password);
      }
    })();
  }, [driver]);

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={handleSubmitDriver}
      validate={validateDriverForm}
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize
    >
      {({ isSubmitting, dirty, isValid }) => {
        return (
          <Form>
            <UpdateDriverForm
              isReadOnly={isReadOnly}
              isDisabled={isReadOnly || !isDriverSelected}
              driver={driver}
              drivers={driversList}
              vehicles={vehicles}
              sections={sections}
              handleSelectDriver={handleSelectDriver}
              isDriverSelected={isDriverSelected}
              isSubmitting={isSubmitting}
              handleAddDriver={onAddDriver}
              handleChangePassword={onChangePassword}
              handleSelectOdfDriver={onSelectOdfDriver}
              odfDrivers={odfDriversList}
              odfDriver={odfDriver}
              odfDisabled={driver?.isNewDriver}
              dirty={dirty || (isDriverChangedForRoute && !driver?.isNewDriver)}
            />
            <ValidationEffect
              isSubmitting={isSubmitting}
              isValid={isValid}
              callback={showValidationError}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default memo(DriverDetailsDialog);
